import {z} from "zod/v4";

export const VenueOverviewTruckStatusCode = z.enum([
    "unknown", "inbound", "awaitingAdmission", "working", "waitingToWork", "idle", "departed"]);
export type VenueOverviewTruckStatusCode = keyof typeof VenueOverviewTruckStatusCode.enum;


